import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { ProfileFormContainer } from "@platform/features/programProfile";
import { AffiliationsFormContainer } from "@platform/features/affiliations";
import { ProgramQuizFormContainer } from "@platform/features/programQuiz";
import type { Action } from "@core/features/actions";

export type Props = {
  /** Program ID */
  programId?: number;
  /** Profile quiz actions to render */
  profileQuizActions: Action[];
  /** Callback when a profile quiz is saved */
  onProfileQuizSaveSuccess: (actionId: number) => void;
  /** Callback when profile is saved */
  onProfileSaveSuccess?: () => void;
};

/**
 * Public Profile tab content.
 * Contains profile form, profile quizzes, and affiliations.
 */
export function ProfilePublicProfileTab({
  profileQuizActions,
  onProfileQuizSaveSuccess,
  onProfileSaveSuccess,
}: Props) {
  return (
    <div
      className="w-full flex flex-col gap-8 pb-8 max-w-3xl"
      data-testid="profile-public-profile-tab"
    >
      <SectionHeading
        title="Basic Details"
        description="Update your basic profile information."
      >
        <ProfileFormContainer
          onSaveSuccess={onProfileSaveSuccess}
          className="w-full flex flex-col gap-6"
        />
      </SectionHeading>

      {profileQuizActions.map((action) => {
        const quizName =
          (action.target_object_data as { name?: string })?.name ??
          "Profile Quiz";
        return (
          <SectionHeading
            key={action.id}
            title={quizName}
            description="Tell us a bit about yourself to help us personalize your experience."
          >
            <ProgramQuizFormContainer
              quizId={action.target_object_id!}
              resourceName={quizName}
              onSaveSuccess={() => onProfileQuizSaveSuccess(action.id)}
              className="w-full flex flex-col gap-6"
            />
          </SectionHeading>
        );
      })}

      <SectionHeading
        title="Affiliations"
        description="Add organizations you're affiliated with and your role there."
      >
        <AffiliationsFormContainer className="w-full flex flex-col gap-6" />
      </SectionHeading>
    </div>
  );
}

export default ProfilePublicProfileTab;
